import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Tick from './tick.json';

const Lottie = dynamic(() => import('react-lottie'), { ssr: false });
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { FacebookShareButton, TwitterShareButton } from 'react-share';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmCheckoutDialog(props) {
  const router = useRouter();

  const [loading, setloading] = useState(false);
  const userWalletRedux = useSelector(
    (state) => state.walletReducer.walletData,
  );

  const handleClose = () => {
    props.setdialogState(false);
    router.push('/collection');
  };

  const goFacebook = () => {
    props.setdialogState(false);
  };

  const goTwitter = () => {
    props.setdialogState(false);
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          width: 380,
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 100 }}
      maxWidth="sm"
      onClose={handleClose}
    >
      <div>
        <div className="dialog-titlebar">
          <div className="dialog-close">
            <button
              className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              type="button"
              onClick={handleClose}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div>
          <DialogContent>
            <div>
              <div className="h-20 mt-4 flex justify-center">
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: Tick,
                  }}
                  speed={1}
                  style={{ margin: 'auto', width: '100%' }}
                />
              </div>
              <div className="py-4 px-16">
                <label className="text-black text-base font-medium text-center mb-4">
                  You successfully purchased{' '}
                  <span style={{ fontStyle: 'italic' }}>
                    {props.nftData ? `'${props.nftData.tokenName}'` : ''}
                  </span>{' '}
                  NFT from{' '}
                  <Link
                    prefetch={false}
                    href={`/collector/${
                      props.nftData ? props.nftData.userId : ''
                    }`}
                  >
                    <a className="link">
                      @{props.ownerName ? props.ownerName : ''}
                    </a>
                  </Link>
                  .
                </label>
              </div>
              <div className="my-4 py-3 px-3 border rounded-md">
                <div className="px-4 py-2 flex">
                  <div className="text-gray-500">Transaction ID</div>
                </div>
                <div className="px-4 py-2 flex">
                  <a
                    href={'https://whatsonchain.com/tx/' + props.txid}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="link">{props.txid.slice(0, 25)}...</div>
                  </a>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              justifyContent: 'center',
              boxSizing: 'border-box',
            }}
          >
            {(() => {
              //   if (loading) {
              //     return (
              //       <div className="flex justify-center	">
              //         <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
              //       </div>
              //     );
              //   } else {
              //     return (
              //       <div className="w-full mb-4 px-4 text-center">
              //         <div div className="mb-2 text-base">
              //           <strong>Share on social media</strong>
              //         </div>
              //         <FacebookShareButton
              //           url={props.nftUrl}
              //           quote={`Hey! I have purchased ${
              //             props.nftData ? props.nftData.tokenName : ""
              //           }  from ${props.ownerName ? props.ownerName : ""}`}
              //           className="Demo__some-network__share-button"
              //         >
              //           {/* <FacebookIcon size={32}  /> */}
              //           <button
              //             className="bg-white text-gray-500 mx-2 my-2 font-normal text-2xl h-16 w-16 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              //             type="button"
              //           >
              //             <i
              //               className="fab fa-facebook-square"
              //               target="_self"
              //               rel="noopener noreferrer"
              //             />
              //           </button>
              //         </FacebookShareButton>
              //         <TwitterShareButton
              //           url={props.nftUrl}
              //           title={`Hey! I have purchased ${
              //             props.nftData ? props.nftData.tokenName : ""
              //           } from ${props.ownerName ? props.ownerName : ""}
              // `}
              //           className="Demo__some-network__share-button"
              //         >
              //           <button
              //             className="bg-white text-gray-500 mx-2 my-2 font-normal text-2xl h-16 w-16 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              //             type="button"
              //           >
              //             <i className="fab fa-twitter" />
              //           </button>
              //           {/* <TwitterIcon size={32}  /> */}
              //         </TwitterShareButton>
              //         {/* <button
              //           className="bg-white text-gray-500 mx-2 my-2 font-normal text-2xl h-16 w-16 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              //           type="button"
              //         >
              //           <a href="https://www.facebook.com/musicart.nft">
              //             <i
              //               className="fab fa-facebook-square"
              //               target="_self"
              //               rel="noopener noreferrer"
              //             />
              //           </a>
              //         </button> */}
              //         {/*
              //         <button
              //           className="bg-white text-gray-500 mx-2 my-2 font-normal text-2xl h-16 w-16 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              //           type="button"
              //         >
              //           <a
              //             href="https://twitter.com/MusicArt_nft"
              //             target="_self"
              //             rel="noopener noreferrer"
              //           >
              //             <i className="fab fa-twitter" />
              //           </a>
              //         </button> */}
              //         {/* <button
              //           className="bg-white text-gray-500 mx-2 my-2 font-normal text-2xl h-16 w-16 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              //           type="button"
              //         >
              //           <a
              //             href="https://www.instagram.com/MusicArt.nft"
              //             target="_self"
              //             rel="noopener noreferrer"
              //           >
              //             <i className="fab fa-instagram" />
              //           </a>
              //         </button> */}
              //         {/*
              //         <button
              //           className="bg-white text-gray-500 mx-2 my-2 font-normal h-16 w-16 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              //           type="button"
              //         >
              //           <i className="fab fa-pinterest"/>
              //         </button> */}
              //       </div>
              //     );
              //   }
            })()}
          </DialogActions>
        </div>
      </div>
    </Dialog>
  );
}
